<template>
  <div id="modal" class="modal plan_search_modal" v-show="modalShown"  v-drag="{handle:'#modal-moving'}" style="position: fixed">
    <div class="modal-main modal-container" id="order_search_modal">
      <div class="modal-header" id="modal-moving">絞り込み検索</div>
      <div v-if="!isDetailPage" class="search_content">
        <div class="container search_li">
          <div class="search_th">物件コード</div>
            <input type="text" class="search_td" v-model="searchForm.propertyCd" maxlength="20">
        </div>
        <div class="container search_li">
          <div class="search_th">物件名</div>
            <input type="text" class="search_td" v-model="searchForm.propertyName" maxlength="20">
        </div>
        <div class="container search_li">
          <div class="search_th">顧客会社名</div>
            <input type="text" class="search_td" v-model="searchForm.clientName" maxlength="20">
        </div>
        <div class="container search_li">
          <div class="search_th">顧客担当者名</div>
            <input type="text" class="search_td" v-model="searchForm.clientPersonName" maxlength="20">
        </div>
        <div class="container search_li">
          <div class="search_th">見積依頼日</div>
          <div class="search_td">
            <input type="date" v-model="searchForm.estAccountReqDateStart">
            <div class="separator">～</div>
            <input type="date" v-model="searchForm.estAccountReqDateEnd">
          </div>
        </div>
        <div class="container search_li">
          <div class="search_th">見積依頼番号</div>
            <input type="text" class="search_td" v-model="searchForm.estAccountReqNo" maxlength="20">
        </div>
        <div class="container search_li">
          <div class="search_th">受注ステータス</div>
          <div class="search_td container flex-wrap">
            <div v-for="(status,index) in statusList" :key="'st-' + index">
              <input type="checkbox" :id="'pro_' + index" @click="setStatus($event, status.code)"
                v-model="planStatus" :value="status.code"/>
              <label :for="'pro_' + index">{{ status.label }}</label>
            </div>
          </div>
        </div>
        <div class="container search_li">
          <div class="search_th">受注日</div>
          <div class="search_td">
            <input type="date" v-model="searchForm.propertyOrderDateStart">
            <div class="separator">～</div>
            <input type="date" v-model="searchForm.propertyOrderDateEnd">
          </div>
        </div>
        <div class="container search_li">
          <div class="search_th">注文番号</div>
            <input type="text" class="search_td" v-model="searchForm.accountOrderNo" maxlength="15">
        </div>
        <div class="container search_li">
          <div class="search_th">担当者１</div>
            <input type="text" class="search_td" v-model="searchForm.personName1" maxlength="15">
        </div>
      </div>
      <div v-else class="search_content">
        <div class="container search_li">
          <div class="search_th">棟名</div>
            <input type="text" class="search_td" v-model="searchForm.propertyBuildingName" maxlength="15">
        </div>
        <div class="container search_li">
          <div class="search_th">フロア名</div>
            <input type="text" class="search_td" v-model="searchForm.propertyFloorName" maxlength="15">
        </div>
        <div class="container search_li">
          <div class="search_th">ルーム名</div>
            <input type="text" class="search_td" v-model="searchForm.propertyRoomName" maxlength="15">
        </div>
        <div class="container search_li">
          <div class="search_th">UMコード</div>
            <input type="text" class="search_td" v-model="searchForm.fileCode" maxlength="15">
        </div>
        <div class="container search_li">
          <div class="search_th">プラン名</div>
            <input type="text" class="search_td" v-model="searchForm.fileName" maxlength="15">
        </div>
        <div class="container search_li">
          <div class="search_th">納入先名</div>
            <input type="text" class="search_td" v-model="searchForm.businessName" maxlength="15">
        </div>
        <div class="container search_li">
          <div class="search_th">着荷日</div>
          <div class="search_td">
            <input type="date" v-model="searchForm.propertyArrivalDateStart">
            <div class="separator">～</div>
            <input type="date" v-model="searchForm.propertyArrivalDateEnd">
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="main_btn pos_left" @click="clear()">クリア</button>
        <button class="main_btn pos_right" @click="close()">閉じる</button>
        <button class="main_btn search_btn" @click="search()">検索</button>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  name: 'PropertySearchModal',
  props: {
    isDetailPage: Boolean
  },
  data () {
    return {
      /** モーダル開閉 */
      modalShown: false,
      statusList: [
        {label: '未受注', code: 0},
        {label: '受注確定', code: 5},
        {label: '受注処理済', code: 10}
      ],
      searchForm: {
        propertyCd: '',
        propertyName: '',
        clientName: '',
        clientPersonName: '',
        estAccountReqDateStart: '',
        estAccountReqDateEnd: '',
        estAccountReqNo: '',
        orderStatus: [],
        propertyOrderDateStart: '',
        propertyOrderDateEnd: '',
        accountOrderNo: '',
        personName1: '',
        propertyId: '',
        propertyBuildingName: '',
        propertyFloorName: '',
        propertyRoomName: '',
        fileCode: '',
        fileName: '',
        businessName: '',
        propertyArrivalDateStart: '',
        propertyArrivalDateEnd: ''
      },
      planStatus: []
    }
  },
  methods: {
    showModal: function () {
      this.modalShown = true
    },
    close: function () {
      this.modalShown = false
    },
    search: function () {
      this.modalShown = false
      this.searchForm.orderStatus = this.planStatus
      this.$emit('onClickSearch', this.searchForm)
    },
    clear: function () {
      this.searchForm = {
        propertyCd: '',
        propertyName: '',
        clientName: '',
        clientPersonName: '',
        estAccountReqDateStart: '',
        estAccountReqDateEnd: '',
        estAccountReqNo: '',
        orderStatus: [],
        propertyOrderDateStart: '',
        propertyOrderDateEnd: '',
        accountOrderNo: '',
        personName1: '',
        propertyId: '',
        propertyBuildingName: '',
        propertyFloorName: '',
        propertyRoomName: '',
        fileCode: '',
        fileName: '',
        businessName: '',
        propertyArrivalDateStart: '',
        propertyArrivalDateEnd: ''
      }
      this.planStatus = []
    },
    setStatus: function (event, code) {
      if (event.target.checked === true) {
        this.planStatus.push(code)
      } else {
        this.planStatus = this.planStatus.filter(s => s !== code)
      }
    },
    formatDate: function (date) {
      if (!date) return ''
      let strDate = moment(date).format('YYYY-MM-DD')
      return strDate
    }
  }
}
</script>

<style src="../../../css/order/order_search.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
.modal-container {
  max-width: 40%;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/list/modal/PropertySearchModal.vue